import * as Yup from 'yup';

export const costChargesValidationSchema = () =>
  Yup.object().shape({
    chargesAndCost: Yup.object().shape({
      policyCost: Yup.number().typeError('Required').required('Required'),
      chargesPercentage: Yup.number()
        .typeError('Required')
        .required('Required'),
      TPAFeesAmount: Yup.number().typeError('Required').required('Required')
    })
  });
